import React, {useState, useEffect, useRef} from 'react';
import {
    saveMsg,
    success,
    updateMsg,
    error,
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import * as Yup from "yup";
import { useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {currencyService} from "../../../jwt/_services/promotions/currencyService";
import {confirmAlert} from "react-confirm-alert";
import FirebaseTarget from "../../../components/firebaseTarget/firebaseTarget";
import CurrencyMainForm from "./_main_form";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function CurrencyForm(props) {
    const [editMode] = useState(!!props?.item?.id);
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);

    const [status, setStatus] = useState(props.item?.status !== undefined ? props.item?.status : null);
    const [saleActivityStatus, setSaleActivityStatus] = useState(props.item?.saleActivityStatus !== undefined ? props.item?.saleActivityStatus : null);
    const [loading, setLoading] = useState(false);
    const [sepMiles, setSepMiles] = useState(editMode ? props.item.sepMiles : null)
    const [sepDecimal, setSepDecimal] = useState(editMode ? props.item.sepDecimal : null)

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            uid: savedData?.uid,
            name: savedData?.name,
            icon: savedData?.icon,
            symbol: savedData?.symbol,
            currency: savedData?.currency,
            countryCode: savedData?.countryCode,
            isoPayment: savedData?.isoPayment,
            flag: savedData?.flag,
            status: status
        }
    });


    const separadores = [
        { value: ',', label: ',' },
        { value: '.', label: '.' },
        { value: '-', label: '-' }
      ]


    //Para establecer el separador de miles
    useEffect(() => {
        if(editMode && props.item.sepMiles != null){
            let opt = separadores.find( s => s.value === props.item.sepMiles)
            setSepMiles(opt)
        }
    }, []);

    //Para establecer el separador de decimales
    useEffect(() => {
        if(editMode && props.item.sepDecimal != null){
            let opt = separadores.find( s => s.value === props.item.sepDecimal)
            setSepDecimal(opt)
        }
    }, []);


    const confirmSubmit= (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) =>
            <FirebaseTarget
                className={"currency"}
                data={data}
                onSubmit={onSubmit}
                onClose={onClose}
            />
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            currency : {
                id          : savedData?.id,
                uid         : savedData?.uid,
                name        : data?.name,
                icon        : data?.icon,
                symbol      : data?.symbol,
                currency    : data?.currency,
                countryCode : data?.countryCode,
                isoPayment  : data?.isoPayment,
                flag        : data?.flag,

                // booleans
                status : status,
                saleActivityStatus : saleActivityStatus
            }
        };

        if (sepDecimal.value != null){
            dataRequest.currency.sepDecimal = sepDecimal.value;
        }
        if (sepMiles.value != null){
            dataRequest.currency.sepMiles = sepMiles.value;
        }

        setLoading(true);
        if (!editMode) {
            //Save
            return currencyService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            dataRequest.currency.id = id

            return currencyService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
    }

    return (
        <>
            {loading && showLoader()}
            <CurrencyMainForm
                handleSubmit={handleSubmit}
                submit={onSubmit}
                register={register}
                errors={errors}
                reset={reset}
                toggleParent={props.toggleParent}
                disableInputs={disableInputs}
                separadores={separadores}
                sepMiles={sepMiles}
                setSepMiles={setSepMiles}
                sepDecimal={sepDecimal}
                setSepDecimal={setSepDecimal}
                status={status}
                setStatus={setStatus}
                saleActivityStatus={saleActivityStatus}
                setSaleActivityStatus={setSaleActivityStatus}
                saveSuccess={saveSuccess}
                editMode={ editMode }
                showHistory = { showHistory }
            />

            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </>
    )
}